/* src/app/admin-dashboard/admin-dashboard.component.css */
.announcement {
  height: 20px;
  text-align: center;
  width: 100%;
  background: #ffff88;
  color: black;
  font-family: Arial, sans;
  padding: 0;
  vertical-align: middle;
  font-size: 0.9em;
}
/*# sourceMappingURL=admin-dashboard.component.css.map */
